import React, { useEffect, useRef } from 'react';
import TwilioVideoApp from './TwilioVideoApp';
import TwilioAppStateProvider, { useTwilioAppState } from './state';
import generateConnectionOptions from './utils/generateConnectionOptions';
import { endCall } from './utils';
import Video from 'twilio-video';
import { VideoProvider } from './components/VideoProvider';

const VideoApp = ({ appointmentDetails, localParticipantRole, waitingRoomMsg, twilioDiagnosticsSettings, kickoutGuest, providerButtons }) => {
    const { error, setError, settings, tokenFailure, setTokenFailure, onTwilioEndCall, isPermissionToDevices, onTwilioRoomError, twilioSettings } = useTwilioAppState();

    const connectionOptions = generateConnectionOptions(twilioSettings ? twilioSettings : { settings, isDynamicSettings: false });
    return (
        <VideoProvider options={connectionOptions} onError={setError} onDisconnect={onTwilioEndCall} kickoutGuest={kickoutGuest}>
            <TwilioVideoApp appointmentDetails={appointmentDetails} error={error} isBrowserSupported={Video.isSupported} tokenFailure={tokenFailure} dismissTokenFailure={() => setTokenFailure(null)} onTwilioEndCall={onTwilioEndCall} isPermissionToDevices={isPermissionToDevices} onTwilioRoomError={onTwilioRoomError} localParticipantRole={localParticipantRole} waitingRoomMsg={waitingRoomMsg} twilioDiagnosticsSettings={twilioDiagnosticsSettings} providerButtons={providerButtons} />
        </VideoProvider>
    );
};

const TwilioMainComponent = ({ appointmentDetails, twilioToken, twilioRoomName, isFetchingTwilioToken, source, onConnected, onError, isFromNonLogin, isSDCVisit, onTwilioEndCall, isPermissionToDevices, error, twilioUserName, onTwilioRoomError, twilioSettings, localParticipantRole, waitingRoomMsg, twilioDiagnosticsSettings, kickoutGuest, providerButtons }) => {
    const _isMounted = useRef(true);
    useEffect(() => {
        return () => {
            _isMounted.current = false;
            endCall();
        }
    }, []);

    return (
        <TwilioAppStateProvider appointmentDetails={appointmentDetails} token={twilioToken} roomName={twilioRoomName} isFetching={isFetchingTwilioToken} source={source} twilioUserName={twilioUserName} localParticipantRole={localParticipantRole} providerButtons={providerButtons}
            onConnected={onConnected} onError={onError} isFromNonLogin={isFromNonLogin} isSDCVisit={isSDCVisit} onTwilioEndCall={onTwilioEndCall} isPermissionToDevices={isPermissionToDevices} error={error} onTwilioRoomError={onTwilioRoomError} _isMounted={_isMounted} twilioSettings={twilioSettings}
        > <VideoApp appointmentDetails={appointmentDetails} localParticipantRole={localParticipantRole} waitingRoomMsg={waitingRoomMsg} twilioDiagnosticsSettings={twilioDiagnosticsSettings} kickoutGuest={kickoutGuest} providerButtons={providerButtons} />
        </TwilioAppStateProvider>
    );

}
export default TwilioMainComponent;